module.exports = __webpack_public_path__ + "static/img/about01.45d6460.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about01.png
// module id = UY0n
// module chunks = 1